import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-cliente",
    templateUrl: "./dialog-cliente.component.html",
    styleUrls: ["./dialog-cliente.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogClienteComponent implements OnInit {
    formCliente: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogClienteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _validadoresFormSrvc: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        this.initForm();
        //console.log(this.data);
    }

    initForm() {
        this.formCliente = this.fb.group({
            razonSocial: [
                this.data?.cliente?.razonSocial || null,
                { validators: [Validators.required, Validators.minLength(3), Validators.maxLength(100)] },
            ],
            rut: [
                this.data?.cliente?.rut || null,
                {
                    validators: [
                        Validators.required,
                        this._validadoresFormSrvc.validadorRut(),
                    ],
                },
            ],
        });
    }

    get razonSocial() {
        return this.formCliente.get("razonSocial");
    }
    get rut() {
        return this.formCliente.get("rut");
    }
}
